import { Model } from 'pinia-orm';
import Company from './Company';
import Application from './Application';
import User from './User';

export default class Task extends Model {

    static get entity() {
        return 'tasks';
    }

    static fields() {
        return {
            id: this.uid(),
            company_id: this.attr(null),
            creator_id: this.attr(null),
            assignee_id: this.attr(null),
            subject_id: this.attr(null),
            subject_type: this.attr(null),
            subject_title: this.attr(null),
            title: this.attr(''),
            notes: this.attr(''),
            private: this.attr(false),
            due_date: this.attr(null),
            finished_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            //relationships
            company: this.belongsTo(Company, 'company_id'),
            creator: this.belongsTo(User, 'creator_id'),
            assignee: this.belongsTo(User, 'assignee_id'),
            subject: this.morphTo([Application], 'subject_id', 'subject_type'),
        }
    }
}
